import { render, staticRenderFns } from "./myaccount.vue?vue&type=template&id=03ecc24d"
import script from "./myaccount.vue?vue&type=script&lang=js"
export * from "./myaccount.vue?vue&type=script&lang=js"
import style0 from "./myaccount.vue?vue&type=style&index=0&id=03ecc24d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports